import { Autocomplete, Grid, TextField } from '@mui/material';
import React from 'react';
import { useInvoicesContext } from './InvoicesContext';

export const InvoicesFilters = () => {
  const { periodFilter, periodOptions, campaignFilter, campaignOptions, onCampaignFilterChange, onPeriodFilterChange } =
    useInvoicesContext();

  // xs=true - take all available space
  // xs=false - do not display at all
  // empty Grid element at the end added for keeping inputs at left on md screen
  return (
    <Grid container spacing={2} sx={{ '& .MuiGrid-item:first-of-type': { pl: 0 }, '& .MuiGrid-item': { pt: 0 } }}>
      <Grid item xs={true} md={3}>
        <Autocomplete
          size="small"
          disableClearable
          options={periodOptions}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          value={periodFilter}
          onChange={(_, newValue) => {
            onPeriodFilterChange(newValue);
          }}
          renderInput={(params) => <TextField {...params} label="Rechnungszeitraum" fullWidth />}
        />
      </Grid>
      <Grid item xs={true} md={4}>
        <Autocomplete
          size="small"
          disableClearable
          options={campaignOptions}
          getOptionLabel={(option) => option.label}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            );
          }}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          value={campaignFilter}
          onChange={(_, newValue) => {
            onCampaignFilterChange(newValue);
          }}
          renderInput={(params) => <TextField {...params} label="Kampagnen" fullWidth />}
        />
      </Grid>
      <Grid item xs={false} md={5}></Grid>
    </Grid>
  );
};
